import { useCallback, useContext } from 'react';
import { FirebaseAppContext } from 'libs.firebase_react';
import { AuthContext } from 'libs.react_internal';
import { DataReportsContext } from '../../../contexts/data_reports/data_reports.context';
export const useReportAnalytics = (studyId, reportId) => {
    const { logEvent } = useContext(FirebaseAppContext);
    const { entityId, user } = useContext(AuthContext);
    const { selectedTestEnv, activeReportsTab } = useContext(DataReportsContext);
    const environment = activeReportsTab === 0 ? 'test' : 'prod';
    const logReportEvent = useCallback((eventName, eventData) => {
        logEvent(eventName, {
            study_id: studyId,
            report_id: reportId,
            entity_id: entityId,
            account_id: user?.path ?? user?.id,
            environment,
            test_env_id: selectedTestEnv.value || undefined,
            ...eventData,
        });
    }, [logEvent, studyId, reportId, entityId, user?.path, user?.id, environment, selectedTestEnv.value]);
    return { logReportEvent };
};
